// 応募, 推薦, 社内応募のエントリー削除時にimportして使います
import ApiClient from 'clients/api_client'
import Modal from 'react-overlays/lib/Modal'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { setModalStyle } from 'supports/modal_style_helper'

export default class EntryDeleteModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  handleSubmit(e) {
    e.preventDefault()

    const { url } = this.props

    this.setState({
      loading: true
    })

    ApiClient.delete(url).then(() => {
      // リロードが走るのでstateは戻さない
      window.location.reload(true)
    })
  }

  render() {
    const { isOpened, onCancel, onShowEditModal } = this.props
    const { loading } = this.state

    return (
      <Modal show={isOpened} onShow={() => setModalStyle(this.modal)}>
        <div className="modal modal-delete">
          <div className="modal-bg" onClick={onCancel} role="presentation" />
          <div
            className="modal-in"
            ref={ref => {
              this.modal = ref
            }}
          >
            <div className="modal-header">
              <div className="title">{I18n.t('components.entry_delete_modal.title')}</div>
            </div>
            <div className="modal-content">
              <form onSubmit={e => this.handleSubmit(e)}>
                <div className="modal-form">
                  <div>
                    {I18n.t('components.entry_delete_modal.message.delete.confirm')}
                    <br />
                    <strong>{I18n.t('components.entry_delete_modal.message.delete.attention')}</strong>
                  </div>
                </div>
                <div className="modal-submit">
                  <input
                    type="button"
                    className="btn btn-delete"
                    disabled={loading}
                    defaultValue={
                      loading ? I18n.t('components.entry_delete_modal.button.deleting') : I18n.t('common.button.delete')
                    }
                    onClick={e => this.handleSubmit(e)}
                  />
                  <input
                    type="button"
                    className="btn btn-default"
                    disabled={loading}
                    value={I18n.t('common.button.cancel')}
                    onClick={onShowEditModal}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

EntryDeleteModal.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onShowEditModal: PropTypes.func.isRequired
}
